import type { ArticleApprovalState } from '@/lib/content-doctrine/article-progress';

export interface ApprovalItemRecord {
  itemId: string;
  requestId: string;
  createdAt: string;
  refHash: string | null;
  requestStatus: string | null;
  decisionId: string | null;
  verdict: string | null;
}

export interface ResolvedApproval {
  state: ArticleApprovalState;
  decisionId: string | null;
}

export function resolveApprovalForHash(
  items: readonly ApprovalItemRecord[],
  currentHash: string | null,
): ResolvedApproval {
  const articleItems = items
    .filter((item) => item.refHash)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  if (articleItems.length === 0) return { state: 'not_sent', decisionId: null };
  if (!currentHash) return { state: 'stale', decisionId: null };
  const matching = articleItems.filter((item) => item.refHash === currentHash);
  if (matching.length === 0) return { state: 'stale', decisionId: null };

  const decided = matching.find((item) => item.verdict);
  if (decided?.verdict === 'approved') {
    return { state: 'approved', decisionId: decided.decisionId };
  }
  if (decided?.verdict === 'changes_requested') return { state: 'changes', decisionId: null };
  const newest = matching[0];
  if (newest && newest.requestStatus && newest.requestStatus !== 'draft') {
    return { state: 'waiting', decisionId: null };
  }
  return { state: 'not_sent', decisionId: null };
}
